import { Pipe, PipeTransform } from "@angular/core";

/**
 * Filtra tags HTML (exceto <br> e <hr>) para substituir os caracters '<' e '>' por HTML entities.
 */
@Pipe({
    name: "escapeTagsExceptLineAndThematicBreak"
})
export class EscapeTagsExceptLineAndThematicBreakPipe implements PipeTransform {

    transform(input: string): string {
        return input.replace(/<(?!br|hr|b|\/b)/g, "&lt;").replace(/(?<!br|hr|b|\/b)>/g, "&gt;");
    }
}
